import Skeleton from "react-loading-skeleton";
import "./styles.scss";

const HeadingSkeleton = ({ containerStyle = {} }) => {
  return (
    <div className="heading-skeleton-container" style={{ ...containerStyle }}>
      <Skeleton
        height={27}
        width={"75%"}
        baseColor="#F8FAFC"
        highlightColor="#E3E8EF"
        className="heading-skeleton"
      />
      <Skeleton
        count={3}
        height={18}
        baseColor="#F8FAFC"
        highlightColor="#E3E8EF"
        className="description-skeleton"
      />
    </div>
  );
};

export default HeadingSkeleton;
